import styled from 'styled-components/macro'
import createSvgIcon from './createSvgIcon'

const AutosaveIcon = createSvgIcon(
  <g>
    <path
      d="M8 2.5C6.81331 2.5 5.65328 2.85189 4.66658 3.51118C3.67989 4.17047 2.91085 5.10754 2.45673 6.2039C2.0026 7.30026 1.88378 8.50666 2.11529 9.67054C2.3468 10.8344 2.91825 11.9035 3.75736 12.7426C4.59648 13.5818 5.66558 14.1532 6.82946 14.3847C7.99335 14.6162 9.19975 14.4974 10.2961 14.0433C11.3925 13.5892 12.3295 12.8201 12.9888 11.8334C13.6481 10.8467 14 9.68669 14 8.5"
      stroke="var(--text-secondary)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </g>,
  'Autosave'
)

export default styled(AutosaveIcon)`
  path {
    transform-origin: center;
    transform: translateX(7px) translateY(6.5px);
  }
`
